module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAYAAACcuBHKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD+SURBVHgB7dZhDcIwEAXgJ2ESJgEJkzAHIAEHIAEH4AAJSEBCJSABdkkvKU17u2677k9fciFhW+5br0sKtLSU5T2Vm+qCnTJO1XvE1/+eUDm8An0AYcyASuHGKQjV3f9fBSFBzDFxQwlitl9SzSSICSbXaA7CIzJFaEZD147YYL9IiBwkBMT3dliQOUQMyQFC4AGF0SBCiATg+qAwWgTd1ymfcSiMBhGOgFck9xytwoDCaN6qx/8IUhBqfoXBxkwBUpAnjD5RCcBFx4BFb65BzAGcB2wWVwBYNXctQgLcLJrHiBzghUqHmhSADr8DKuURAWjuZ+yQEYabrqUllx9NjwcJo8vT4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/androidPlayIcon.png
// module id = 12
// module chunks = 1